import React, { useState } from 'react';
import UserProfilePopover from './UserProfilePopover';
import MHLogo from '../assets/MHlogo.svg';
import './Header.css';
import Aurora from './Intro/Aurora/Aurora';
import { Link, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';

const Header = () => {
    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    return (
        <header className="header-container">
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '70px',
                    zIndex: 0,
                    pointerEvents: 'none',
                    overflow: 'hidden',
                }}
            >
                <Aurora
                    colorStops={['#01F5B0',  '#28C1F9','#01F5B0',]}
                    blend={0.5}
                    amplitude={0.6}
                    speed={0.5}
                />
            </div>
            <div className="header-logo-wrapper">
                <img src={MHLogo} alt="Logo" className="header-logo" />
            </div>

            <div className="header-flex-spacer" />
            <div className="header-right-group">
                <div className="header-nav-links-wrapper">
                    <nav className="header-nav-links">
                        <Link
                            to="/home"
                            className={`header-nav-btn${location.pathname === '/home' ? ' active' : ''}`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/myapplications"
                            className={`header-nav-btn${location.pathname === '/myapplications' ? ' active' : ''}`}
                        >
                            Dashboard
                        </Link>
                        <Link
                            to="/instances"
                            className={`header-nav-btn${location.pathname === '/instances' ? ' active' : ''}`}
                        >
                            Instances
                        </Link>

                    </nav>
                </div>

                <div className="header-profile-desktop">
                    <UserProfilePopover />
                </div>
                <button className="header-hamburger" onClick={handleMenuOpen} aria-label="Open menu">
                    <MenuIcon style={{ color: '#fff', fontSize: 32 }} />
                </button>
                <Menu
                    anchorEl={anchorEl}
                    open={isMenuOpen}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{ style: { minWidth: 200, background: '#181818', color: '#fff' } }}
                >
                    <MenuItem component={Link} to="/home" onClick={handleMenuClose} selected={location.pathname === '/home'}>
                        Home
                    </MenuItem>
                    <MenuItem component={Link} to="/myapplications" onClick={handleMenuClose} selected={location.pathname === '/myapplications'}>
                        My Applications
                    </MenuItem>
                    <Divider style={{ background: '#333', margin: '8px 0' }} />
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
                        <UserProfilePopover />
                       
                    </div>
                </Menu>
            </div>
        </header>
    );
};

export default Header; 